import { defaultAxios } from '@/services/http';
import router from '@/router';

export default {
  async init() {
    defaultAxios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const { response } = error;
        if (response && response.status === 401 && response.data.type === 'UNAUTHORIZED_ACCESS') {
          return this.logout(false);
        }
        return Promise.reject(error);
      },
    );
  },
  createLoginRequest(email, method, turnstileToken) {
    return defaultAxios.post('auth/login/createLoginRequest', { email, method, turnstileToken });
  },
  refreshUserObject() {
    return defaultAxios.get('user/@me');
  },
  refreshCourseObject() {
    return defaultAxios.get('user/@me/activeCourse');
  },
  getLoginMethods(email, turnstileToken) {
    return defaultAxios.post('auth/login/getLoginMethods', { email, turnstileToken });
  },
  login(loginToken, challengeCode, password, turnstileToken) {
    return defaultAxios.post('auth/login/submitLoginRequest', { loginToken, challengeCode, password, turnstileToken });
  },
  logout(api = true) {
    if (api) defaultAxios.get('user/@me/logout');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('courseInfo');
    router.push('/login');
  },
  registerUser(first_name, last_name, email, password, recaptcha) {
    return defaultAxios.post('user/register', {
      first_name,
      last_name,
      email,
      password,
      recaptcha,
    });
  },
  refreshToken() {
    return defaultAxios
      .post('auth/refresh', {
        refresh_token: localStorage.getItem('refreshToken'),
      })
      .catch(() => {
        this.logout();
      });
  },
};
